import { AttachMoneyOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import CustomCard from "components/CustomCard";
import CustomLink from "components/CustomLink";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect, useState } from "react";
import RevenueVsExpensesChart from "./RevenueVsExpensesChart";
import Forecast from "../components/Forecast";
import moment from "moment";

const Payments = ({ data, setDialogTitle, getData, revenueForecast, expensesForecast }) => {
    const { bt } = useBizTypeTranslation();
    const [revenueTotalByMonth, setRevenueTotalByMonth] = useState([])
    const [expensesTotalByMonth, setExpensesTotalByMonth] = useState([])

    const getSumValues = (forecast = []) => {
        const sumRow = forecast.find((item) => item.name === "SUM");
        if (!sumRow) return [];
        const { id, monthDetails, name, summary, ...monthsOnly } = sumRow;
        return Object.values(monthsOnly);
    };

    useEffect(() => {
        setRevenueTotalByMonth(getSumValues(revenueForecast));
        setExpensesTotalByMonth(getSumValues(expensesForecast));
    }, [revenueForecast, expensesForecast]);

    return (
        <CustomCard>
            <Stack direction="row" justifyContent="space-between">
                <Typography fontSize={18} fontWeight="bold"> {bt("PAYMENTS")}</Typography>
                <CustomLink title="IMPORT_DATA" onClick={() => getData()} />
            </Stack>

            <Stack
                direction={{ xs: "column", md: "row-reverse" }}
                spacing={5}
                alignItems="start"
                justifyContent="space-between"
            >

                <Stack
                    width={{ xs: "100%", md: "auto" }}
                    pt={{ xs: 0, md: 6 }}
                    direction="column"
                    justifyContent={{ xs: "center", md: "start" }}
                    spacing={{ xs: 1, md: 2 }}
                >
                    {data?.filter(i => i?.show)?.map((st, idx) => {
                        return (
                            <CustomCard
                                key={idx}
                                alignItems="center"
                                direction="row"
                                width={{ xs: "100%", md: 260 }}
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                    setDialogTitle(bt(st?.name));
                                    st?.onClick(st?.list);
                                }}
                            >
                                <Stack
                                    width={{ xs: 50, md: 70 }}
                                    height={{ xs: 50, md: 70 }}
                                    bgcolor={st?.iconBgColor}
                                    borderRadius={10}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <AttachMoneyOutlined sx={{ color: st?.iconColor }} />
                                </Stack>

                                <Stack padding={{ xs: 0, md: 1 }}>
                                    <Stack height="100%" alignItems="center" direction="row" spacing={0.5}>
                                        <Typography fontSize={{ xs: 12, md: 14 }}>
                                            {bt(st?.name)}
                                        </Typography>
                                        <Typography fontSize={{ xs: 12, md: 14 }}>
                                            {`${st?.subValue ? `(${st?.subValue})` : ""}`}
                                        </Typography>
                                    </Stack>

                                    <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">
                                        {st?.value}
                                    </Typography>
                                </Stack>
                            </CustomCard>
                        )
                    })}


                </Stack>

                <Stack
                    width="100%"
                    sx={{ overflowX: "scroll" }}
                    spacing={{ xs: 2, md: 0 }}
                >
                    <Forecast
                        hasTotal
                        title={`${bt("REVENUE_FORECAST")} (${moment().format("Y")})`}
                        data={revenueForecast}
                    />

                    <Forecast
                        hasTotal
                        title={`${bt("EXPENSES_FORECAST")} (${moment().format("Y")})`}
                        data={expensesForecast}
                    />

                    <RevenueVsExpensesChart
                        expensesTotalByMonth={expensesTotalByMonth}
                        revenueTotalByMonth={revenueTotalByMonth}
                    />
                </Stack>

            </Stack>
        </CustomCard>
    );
};

export default Payments;